module.exports = "/packs/012-ff3c5fb8d54a37f19fd83c591fef5835.jpg";